import { ToastContext } from '@/context/toast/index.js'
import useModal from '@/hooks/use-modal/index'
import usePackages from '@/hooks/use-packages/index.js'
import classname from 'classnames'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import ViewFullMessage from './view-message-activity-log-modal.jsx'
import { featureConstant } from "@/constants/configuration/feature.js";
import { useFeature } from "@/hooks/use-feature/index";
import { renderUserEmailStacked } from '@/utils/formatUserEmail';

const ActivityLog = ({ title, packageInfo }) => {
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const { activityLog, getActivityLog, packageErrorMsg } = usePackages()
	const [loadMore, setLoadMore] = useState(false)
	const [selectedData, setSelectedData] = useState()
	const { addToastMessage } = useContext(ToastContext)

	const {
		visible: isViewFullMessageVisible,
		show: showViewFullMessage,
		hide: hideViewFullMessage,
	} = useModal()

	const init = () => {
		if (packageInfo?.type) {
			getActivityLog(packageInfo?.id)
		}
	}

	useEffect(init, [packageInfo])

	useEffect(() => {
		if (packageErrorMsg) {
			addToastMessage("Failed to get activity log", "error")
		}
	}, [packageErrorMsg])

	const loadMoreClass = classname({
		'package-audit-log-wrapper': true,
		'package-audit-load-more--scroll': loadMore,
	})

	const auditData = activityLog?.map((item) => {
		return (
			<>
				<div className="package-activity-log-container" key={item.id}>
					<div className="package-activity-log--label package-modal-flex">
						<span className="package-activity-log---text">{item?.activity}</span>
						{item?.moreInfo && (
							<>
								<span
									className="package-modal--view-message"
									onClick={() => {
										setSelectedData(item)
										showViewFullMessage()
									}}
								>
									View Message
								</span>
							</>
						)}
					</div>
					<div className="package-activity-log--subcontent">
						<span>{moment(new Date(item?.timestamp)).format('DD MMM, HH:mm')}</span>
						<span>{item?.orgName}</span>
						<div className={`soft-delete__tooltip-container__width ${isSoftDeleteUserEnabled ? 'soft-delete__tooltip-container' : ''}`}>{isSoftDeleteUserEnabled ? renderUserEmailStacked(item?.user) : item?.user}{isSoftDeleteUserEnabled && item?.user?.user_status === 'DELETED' && <div className="tooltiptexts eform-tooltip-text">{renderUserEmailStacked(item?.user)}</div>}</div>
					</div>

					<hr />
				</div>
			</>
		)
	})

	return (
		<>
			<div className="package-activity-log">
				<div className="package-activity__title">{title}</div>
				{activityLog?.length > 0 ? (
					<>
						<div className={loadMoreClass}>{auditData}</div>
						{activityLog?.length > 5 && (
							<>
								{!loadMore && (
									<div
										className="package-audit-load-more"
										onClick={() => setLoadMore(!loadMore)}
									>
										Load More
									</div>
								)}
							</>
						)}
					</>
				) : (
					<div className="package-activity-log--no-messgaes">No Data Available</div>
				)}
			</div>
			<ViewFullMessage
				visible={isViewFullMessageVisible}
				close={hideViewFullMessage}
				data={selectedData}
			/>
		</>
	)
}

export default ActivityLog
